import React, { useState, useEffect } from 'react';
import './Home.css';
import { ContactoService } from '../services/ContactoService';

function Home() {
  // Estado del formulario
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    mensaje: ''
  });
  const [enviando, setEnviando] = useState(false);
  const [mensajeResultado, setMensajeResultado] = useState(null);

  // Estado del carrusel
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [itemsPerSlide, setItemsPerSlide] = useState(3);

  const carouselItems = [
    { id: 1, image: '/images/ada5web.jpeg', title: 'ADA5WEB' },
    { id: 2, image: '/images/consorciosenredplus.jpeg', title: 'CONSORCIOSENRED+' },
    { id: 3, image: '/images/adasueldos.png', title: 'ADA SUELDOS' },
    { id: 4, image: '/images/ada5web.jpeg', title: 'ADA5WEB' },
    { id: 5, image: '/images/consorciosenredplus.jpeg', title: 'CONSORCIOSENRED+' },
    { id: 6, image: '/images/adasueldos.png', title: 'ADA SUELDOS' }
  ];

  const totalSlides = Math.ceil(carouselItems.length / itemsPerSlide);

  // Detectar tamaño de pantalla para items por slide
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setItemsPerSlide(1);
      } else {
        setItemsPerSlide(3);
      }
    };

    // Ejecutar al cargar
    handleResize();

    // Agregar listener
    window.addEventListener('resize', handleResize);

    // Limpiar listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-play del carrusel
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [isPaused, totalSlides]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  // Handler para envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación personalizada en español
    if (!formData.nombre || formData.nombre.trim() === '') {
      setMensajeResultado({
        tipo: 'error',
        texto: 'Por favor ingrese su nombre'
      });
      return;
    }

    if (!formData.email || formData.email.trim() === '') {
      setMensajeResultado({
        tipo: 'error',
        texto: 'Por favor ingrese su email'
      });
      return;
    }

    // Validación de formato de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setMensajeResultado({
        tipo: 'error',
        texto: 'Por favor ingrese un email válido'
      });
      return;
    }

    if (!formData.mensaje || formData.mensaje.trim() === '') {
      setMensajeResultado({
        tipo: 'error',
        texto: 'Por favor ingrese su mensaje'
      });
      return;
    }

    setEnviando(true);
    setMensajeResultado(null);

    try {
      await ContactoService.enviarContacto(formData);

      // Éxito
      setMensajeResultado({
        tipo: 'success',
        texto: '¡Mensaje enviado correctamente! Nos contactaremos pronto.'
      });

      // Limpiar formulario
      setFormData({
        nombre: '',
        email: '',
        mensaje: ''
      });
    } catch (error) {
      // Error
      setMensajeResultado({
        tipo: 'error',
        texto: error.message || 'Error al enviar el mensaje. Intente nuevamente.'
      });
    } finally {
      setEnviando(false);
    }
  };

  // Handler para cambios en inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="home">
      {/* Header con Logo */}
      <header className="header">
        <div className="container header-container">
          <img
            src="/images/logo-cer.png"
            alt="Logo ConsorciosEnRed+"
            className="logo"
          />
          <h2 className="header-title">Consorcios En Red+</h2>
          <button className="btn-header">Ver Mis Expensas</button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section" style={{backgroundImage: 'url(/images/hero-bg.jpeg)'}}>
        <div className="container hero-content">
          <h1 className="hero-title">¡Hola! Bienvenido</h1>
          <p className="hero-subtitle">
            La renovada plataforma digital para propietarios, inquilinos y ocupantes que centraliza la gestión del consorcio, el acceso a la información y los servicios del edificio en un solo lugar.
          </p>
          <button className="btn-ingresar" onClick={() => window.location.href = 'https://ada5web.com/loginConsorciosEnRed'}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.5 21.5L23.5 12L2.5 2.5L2.5 9.5L16.5 12L2.5 14.5L2.5 21.5Z" fill="white" transform="rotate(-45 12 12)"/>
            </svg>
            INGRESAR
          </button>
        </div>
      </section>

      {/* Quienes Somos */}
      <section className="about-section">
        <div className="container">
          <h2 className="section-title">Quienes somos?</h2>
          <p className="section-description">
            Somos una empresa de sistemas especializada en propiedad horizontal, countries y barrios cerrados.
          </p>
        </div>
      </section>

      {/* Info Section */}
      <section className="info-section">
        <div className="container info-content">
          <div className="info-image">
            <img src="/images/manwithphone.jpeg" alt="Persona usando móvil" />
          </div>

          <div className="info-column">
            <div className="info-block">
              <div className="info-icon">
                <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1762577643" class="svg u_1762577643" data-icon-custom="true" data-icon-name="detail_5139009.svg">
                  <g>
                  <path d="m94.301 43.332c-1.6484-10.93-7.2812-20.867-15.812-27.898-8.5312-7.0273-19.359-10.656-30.406-10.188-11.047 0.47266-21.527 5.0117-29.426 12.742-7.9023 7.7305-12.668 18.113-13.379 29.145-0.71094 11.031 2.6797 21.938 9.5234 30.621 6.8438 8.6797 16.656 14.527 27.551 16.414 2.5273 0.41797 5.0859 0.625 7.6484 0.62109 6.4648 0.007813 12.855-1.3828 18.73-4.082 0.96484-0.48047 2.0664-0.625 3.125-0.41406l12.336 2.8477v-0.003906c2.5 0.57422 5.1172-0.20703 6.8906-2.0547 1.7773-1.8516 2.4531-4.4961 1.7812-6.9688l-3.0195-11.105h-0.003906c-0.28516-1.1562-0.13672-2.375 0.41797-3.4297 3.9766-8.1367 5.3828-17.289 4.043-26.246zm-10.508 31.336 3.0234 11.098v-0.003906c0.097656 0.35547 0.003906 0.73828-0.25391 1.0039s-0.63672 0.375-0.99609 0.28906l-12.332-2.8477c-2.4102-0.53125-4.9258-0.23828-7.1484 0.83594-10.883 5.0078-23.48 4.6719-34.082-0.91797-10.602-5.5859-18-15.785-20.02-27.598s1.5703-23.895 9.7109-32.688c7.2812-7.9102 17.551-12.402 28.305-12.383 1.1289 0 2.2656 0.050781 3.4023 0.14453v0.003907c12.633 1.1094 23.902 8.3672 30.145 19.402 6.2383 11.035 6.6445 24.438 1.082 35.828-1.2227 2.4219-1.5195 5.207-0.83594 7.832z">
                  </path>
                  <path d="m56.25 67.707h-3.125v-26.039c0-1.7266-1.3984-3.125-3.125-3.125h-2.082c-1.5195 0.003906-2.8164 1.1016-3.0703 2.5977-0.25781 1.5 0.59766 2.9648 2.0273 3.4766v23.09h-3.125c-1.7266 0-3.125 1.4023-3.125 3.125 0 1.7266 1.3984 3.125 3.125 3.125h12.5c1.7266 0 3.125-1.3984 3.125-3.125 0-1.7227-1.3984-3.125-3.125-3.125z">
                  </path>
                  <path d="m54.168 29.168c0 5.5547-8.3359 5.5547-8.3359 0 0-5.5586 8.3359-5.5586 8.3359 0">
                  </path>
                  </g>
                </svg>
              </div>
              <div className="info-text">
                <h3>INFO</h3>
                <p>Desde hace más de 46 años nos dedicamos exclusivamente a brindar servicios para Administradores de Propiedad Horizontal.</p>
              </div>
            </div>

            <div className="info-block">
              <div className="info-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1311955456" className="svg u_1311955456" data-icon-custom="true">
                  <g>
                    <path d="m80.199 66.453c-2.168-3.1055-5.7578-4.9062-9.5469-4.7852-3.7656 0.074219-7.2578 2-9.3281 5.1484l-0.89844 1.3594c-0.34766 0.53906-0.91797 0.89844-1.5547 0.97656-0.625 0.074218-1.2539-0.125-1.7227-0.54688-4.4453-4.4414-8.5547-9.2031-12.293-14.25-3.5938-5.1602-6.7969-10.578-9.5859-16.215-0.25781-0.57422-0.24609-1.2383 0.035157-1.8047 0.27734-0.57813 0.79297-1.0039 1.4102-1.1641l1.5742-0.41797h0.003907c3.6445-0.95703 6.5859-3.6445 7.8672-7.1875 1.2812-3.543 0.73828-7.4883-1.4531-10.555l-5.4688-7.625c-2.0352-2.8398-5.2539-4.5938-8.7422-4.7695-3.4922-0.17188-6.8672 1.2539-9.1758 3.8789l-3.6875 4.168c-3.3555 3.8281-5.6133 8.4961-6.5352 13.5-0.92578 5.0078-0.47656 10.172 1.2891 14.949 3.4336 9.4062 8.1328 18.305 13.969 26.441 5.7773 8.0391 12.609 15.266 20.312 21.488 5.0703 4.0977 11.395 6.3359 17.914 6.3398 3.5859 0 7.1406-0.6875 10.465-2.0312l5.457-2.1992v-0.003906c3.2578-1.3164 5.7305-4.0586 6.707-7.4375 0.97656-3.3789 0.34766-7.0156-1.707-9.8711z"></path>
                    <path d="m71.164 52.242c0.17188 0.027343 0.34375 0.042968 0.51953 0.042968 1.5234-0.003906 2.8242-1.1055 3.0742-2.6055 0.22656-1.3242 0.35156-2.6641 0.37109-4.0039 0.054688-4.8281-1.3203-9.5664-3.9531-13.617-2.6289-4.0469-6.3984-7.2305-10.836-9.1406-1.582-0.69141-3.4258 0.03125-4.1133 1.6172-0.69141 1.582 0.03125 3.4258 1.6133 4.1133 3.3047 1.4258 6.1133 3.793 8.0781 6.8086 1.9609 3.0156 2.9883 6.543 2.9492 10.141-0.015626 1.0195-0.10938 2.0352-0.28125 3.0391-0.13672 0.82031 0.054687 1.6641 0.53906 2.3398 0.48438 0.67578 1.2148 1.1328 2.0391 1.2656z"></path>
                    <path d="m65.914 9.8555c-1.582-0.65625-3.3984 0.082031-4.0742 1.6562-0.67188 1.5742 0.046875 3.3984 1.6133 4.0898 5.8984 2.5117 10.914 6.7227 14.414 12.094 3.5 5.3711 5.3203 11.66 5.2383 18.07-0.023438 1.7812-0.19531 3.5547-0.51562 5.3047-0.30469 1.6992 0.82422 3.3242 2.5234 3.6328 0.18359 0.035156 0.375 0.050781 0.5625 0.050781 1.5078-0.003906 2.8008-1.0859 3.0703-2.5703 0.38281-2.0977 0.58594-4.2188 0.60938-6.3516 0.097656-7.6445-2.0781-15.148-6.25-21.555-4.1758-6.4062-10.16-11.426-17.191-14.422z"></path>
                  </g>
                </svg>
              </div>
              <div className="info-text">
                <h3>RESERVAS</h3>
                <p>Con nosotros vas a poder reservar día, mes, y hora para el uso de los amenities con toda comodidad.</p>
              </div>
            </div>
          </div>

          <div className="info-column">
            <div className="info-block">
              <div className="info-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1230377847" className="svg u_1230377847" data-icon-custom="true">
                  <g>
                    <path d="m34.375 25v-17.543c-0.60156 0.43359-1.1602 0.92578-1.668 1.4688l-18.234 19.902c-0.38281 0.43359-0.73438 0.89453-1.0469 1.3789h15.742c2.875-0.003906 5.2031-2.332 5.207-5.207z"></path>
                    <path d="m77.082 5.207h-35.914c-0.18359 0-0.35938 0.046875-0.54297 0.058594v19.734c-0.003906 6.3281-5.1328 11.453-11.457 11.457h-17.703v0.11719 46.758c0.007812 6.3242 5.1289 11.449 11.453 11.461h54.168-0.003907c6.3281-0.007813 11.453-5.1328 11.461-11.461v-66.664c-0.007813-6.3281-5.1328-11.453-11.461-11.461zm-10.418 70.832-33.332 0.003907c-1.7227 0-3.125-1.4023-3.125-3.125 0-1.7266 1.4023-3.125 3.125-3.125h33.336c1.7227 0 3.125 1.3984 3.125 3.125 0 1.7227-1.4023 3.125-3.125 3.125zm0-16.668-33.332 0.003906c-1.7227 0-3.125-1.3984-3.125-3.125s1.4023-3.125 3.125-3.125h33.336c1.7227 0 3.125 1.3984 3.125 3.125s-1.4023 3.125-3.125 3.125zm0-16.668-16.664 0.003906c-1.7266 0-3.125-1.3984-3.125-3.125 0-1.7227 1.3984-3.125 3.125-3.125h16.668c1.7227 0 3.125 1.4023 3.125 3.125 0 1.7266-1.4023 3.125-3.125 3.125z"></path>
                  </g>
                </svg>
              </div>
              <div className="info-text">
                <h3>MIS EXPENSAS</h3>
                <p>Vas a poder ver toda la información de tus expensas, avisos de pago y recibos en un solo lugar</p>
              </div>
            </div>

            <div className="info-block">
              <div className="info-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1053183121" className="svg u_1053183121" data-icon-custom="true">
                  <g>
                    <path d="m50 5.207c-11.738-0.003906-23.004 4.6172-31.359 12.863 4.75 2.6562 9.8281 4.668 15.109 5.9805 3.2461-10.914 8.7266-18.844 16.25-18.844z"></path>
                    <path d="m60.125 25.254c-2.6719-8.543-6.5156-13.797-10.125-13.797s-7.4531 5.2539-10.125 13.797c3.3516 0.51562 6.7344 0.77734 10.125 0.78906 3.3906-0.011719 6.7734-0.27344 10.125-0.78906z"></path>
                    <path d="m39.875 74.746c2.6719 8.543 6.5156 13.797 10.125 13.797s7.4531-5.2539 10.125-13.797c-6.7109-1.0508-13.539-1.0508-20.25 0z"></path>
                    <path d="m63.48 53.125h-26.961c0.14062 5.2227 0.73438 10.422 1.7812 15.539 7.7461-1.2734 15.652-1.2734 23.398 0 1.0469-5.1172 1.6406-10.316 1.7812-15.539z"></path>
                    <path d="m61.699 31.336c-3.8672 0.62891-7.7812 0.94922-11.699 0.95703-3.918-0.007813-7.832-0.32812-11.699-0.95703-1.0469 5.1172-1.6406 10.316-1.7812 15.539h26.961c-0.14062-5.2227-0.73438-10.422-1.7812-15.539z"></path>
                    <path d="m66.25 24.051c5.2734-1.3125 10.352-3.3242 15.09-5.9805-8.3477-8.2422-19.609-12.863-31.34-12.863 7.5234 0 13.004 7.9297 16.25 18.844z"></path>
                    <path d="m14.477 77.176c5.5273-3.2578 11.492-5.7031 17.715-7.2617-1.125-5.5312-1.7656-11.148-1.9219-16.789h-24.902c0.60156 8.7383 3.7695 17.105 9.1094 24.051z"></path>
                    <path d="m85.523 22.824c-5.5273 3.2578-11.492 5.7031-17.715 7.2617 1.125 5.5312 1.7656 11.148 1.9219 16.789h24.902c-0.60156-8.7383-3.7695-17.105-9.1094-24.051z"></path>
                    <path d="m94.633 53.125h-24.902c-0.15625 5.6406-0.79688 11.258-1.9219 16.789 6.2227 1.5586 12.188 4.0039 17.715 7.2617 5.3398-6.9453 8.5078-15.312 9.1094-24.051z"></path>
                    <path d="m66.25 75.949c-3.2617 10.914-8.75 18.84-16.25 18.84v0.003907c11.738 0.003906 23.004-4.6172 31.359-12.863-4.75-2.6562-9.8281-4.668-15.109-5.9805z"></path>
                    <path d="m33.75 75.949c-5.2734 1.3125-10.352 3.3242-15.09 5.9805 8.3477 8.2422 19.609 12.863 31.34 12.863-7.5234 0-13.004-7.9297-16.25-18.844z"></path>
                    <path d="m30.27 46.875c0.15625-5.6406 0.79688-11.258 1.9219-16.789-6.2227-1.5586-12.188-4.0039-17.715-7.2617-5.3398 6.9453-8.5078 15.312-9.1094 24.051z"></path>
                  </g>
                </svg>
              </div>
              <div className="info-text">
                <h3>USUARIOS</h3>
                <p>Con una identificación de usuario, una contraseña y una respuesta a una pregunta secreta por si se te olvida, podes vincular una o más unidades en uno o más edificios. Para vincular tu unidad, solo necesitas un pin por única vez.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Registro Section */}
      <section className="register-section">
        <div className="container">
          <h2 className="register-title">
            Registrate como Propietario, Inquilino u ocupante y empezá a utilizar todos estos servicios exclusivos para Vos.
          </h2>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features-section">
        <div className="container">
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1024811446" className="svg u_1024811446" data-icon-custom="true">
                  <path d="m77.648 8.8945c1.1133-1.9414 3.5938-2.6094 5.5352-1.4961 1.9414 1.1172 2.6094 3.5938 1.4961 5.5352l-31.16 54.082c-1.5312 2.6602-5.3164 2.6992-6.9336 0.17578l-13.758-21.375c-1.2109-1.8867-0.66406-4.4023 1.2227-5.6133 1.8906-1.2109 4.4023-0.66406 5.6133 1.2227l10.152 15.773 27.836-48.305zm-27.648 88.605c26.234 0 47.5-21.266 47.5-47.5 0-2.2461-1.8203-4.0703-4.0703-4.0703s-4.0703 1.8242-4.0703 4.0703c0 21.734-17.621 39.355-39.355 39.355-21.738 0-39.359-17.621-39.359-39.355s17.621-39.355 39.355-39.355c2.25 0 4.0703-1.8242 4.0703-4.0703 0-2.2461-1.8242-4.0703-4.0703-4.0703-26.234-0.003906-47.5 21.262-47.5 47.496s21.266 47.5 47.5 47.5z" fillRule="evenodd">
                  </path>
                </svg>
              </div>
              <p className="feature-text">
                Ver y/o imprimir Liquidaciones de Expensas, último mes e históricos.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1024811446" className="svg u_1024811446" data-icon-custom="true">
                  <path d="m77.648 8.8945c1.1133-1.9414 3.5938-2.6094 5.5352-1.4961 1.9414 1.1172 2.6094 3.5938 1.4961 5.5352l-31.16 54.082c-1.5312 2.6602-5.3164 2.6992-6.9336 0.17578l-13.758-21.375c-1.2109-1.8867-0.66406-4.4023 1.2227-5.6133 1.8906-1.2109 4.4023-0.66406 5.6133 1.2227l10.152 15.773 27.836-48.305zm-27.648 88.605c26.234 0 47.5-21.266 47.5-47.5 0-2.2461-1.8203-4.0703-4.0703-4.0703s-4.0703 1.8242-4.0703 4.0703c0 21.734-17.621 39.355-39.355 39.355-21.738 0-39.359-17.621-39.359-39.355s17.621-39.355 39.355-39.355c2.25 0 4.0703-1.8242 4.0703-4.0703 0-2.2461-1.8242-4.0703-4.0703-4.0703-26.234-0.003906-47.5 21.262-47.5 47.496s21.266 47.5 47.5 47.5z" fillRule="evenodd">
                  </path>
                </svg>
              </div>
              <p className="feature-text">
                Reservar día, mes, y hora para el uso de los amenities.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1024811446" className="svg u_1024811446" data-icon-custom="true">
                  <path d="m77.648 8.8945c1.1133-1.9414 3.5938-2.6094 5.5352-1.4961 1.9414 1.1172 2.6094 3.5938 1.4961 5.5352l-31.16 54.082c-1.5312 2.6602-5.3164 2.6992-6.9336 0.17578l-13.758-21.375c-1.2109-1.8867-0.66406-4.4023 1.2227-5.6133 1.8906-1.2109 4.4023-0.66406 5.6133 1.2227l10.152 15.773 27.836-48.305zm-27.648 88.605c26.234 0 47.5-21.266 47.5-47.5 0-2.2461-1.8203-4.0703-4.0703-4.0703s-4.0703 1.8242-4.0703 4.0703c0 21.734-17.621 39.355-39.355 39.355-21.738 0-39.359-17.621-39.359-39.355s17.621-39.355 39.355-39.355c2.25 0 4.0703-1.8242 4.0703-4.0703 0-2.2461-1.8242-4.0703-4.0703-4.0703-26.234-0.003906-47.5 21.262-47.5 47.496s21.266 47.5 47.5 47.5z" fillRule="evenodd">
                  </path>
                </svg>
              </div>
              <p className="feature-text">
                Ver y/o imprimir Avisos de Pago, aptos para el pago electrónico y por todos los sistemas de cobro.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1024811446" className="svg u_1024811446" data-icon-custom="true">
                  <path d="m77.648 8.8945c1.1133-1.9414 3.5938-2.6094 5.5352-1.4961 1.9414 1.1172 2.6094 3.5938 1.4961 5.5352l-31.16 54.082c-1.5312 2.6602-5.3164 2.6992-6.9336 0.17578l-13.758-21.375c-1.2109-1.8867-0.66406-4.4023 1.2227-5.6133 1.8906-1.2109 4.4023-0.66406 5.6133 1.2227l10.152 15.773 27.836-48.305zm-27.648 88.605c26.234 0 47.5-21.266 47.5-47.5 0-2.2461-1.8203-4.0703-4.0703-4.0703s-4.0703 1.8242-4.0703 4.0703c0 21.734-17.621 39.355-39.355 39.355-21.738 0-39.359-17.621-39.359-39.355s17.621-39.355 39.355-39.355c2.25 0 4.0703-1.8242 4.0703-4.0703 0-2.2461-1.8242-4.0703-4.0703-4.0703-26.234-0.003906-47.5 21.262-47.5 47.496s21.266 47.5 47.5 47.5z" fillRule="evenodd">
                  </path>
                </svg>
              </div>
              <p className="feature-text">
                Recibir o no por e-mail la Liquidación de Expensas y el Aviso de Pago.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1024811446" className="svg u_1024811446" data-icon-custom="true">
                  <path d="m77.648 8.8945c1.1133-1.9414 3.5938-2.6094 5.5352-1.4961 1.9414 1.1172 2.6094 3.5938 1.4961 5.5352l-31.16 54.082c-1.5312 2.6602-5.3164 2.6992-6.9336 0.17578l-13.758-21.375c-1.2109-1.8867-0.66406-4.4023 1.2227-5.6133 1.8906-1.2109 4.4023-0.66406 5.6133 1.2227l10.152 15.773 27.836-48.305zm-27.648 88.605c26.234 0 47.5-21.266 47.5-47.5 0-2.2461-1.8203-4.0703-4.0703-4.0703s-4.0703 1.8242-4.0703 4.0703c0 21.734-17.621 39.355-39.355 39.355-21.738 0-39.359-17.621-39.359-39.355s17.621-39.355 39.355-39.355c2.25 0 4.0703-1.8242 4.0703-4.0703 0-2.2461-1.8242-4.0703-4.0703-4.0703-26.234-0.003906-47.5 21.262-47.5 47.496s21.266 47.5 47.5 47.5z" fillRule="evenodd">
                  </path>
                </svg>
              </div>
              <p className="feature-text">
                Notificar el pago de tus expensas.
              </p>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" id="1024811446" className="svg u_1024811446" data-icon-custom="true">
                  <path d="m77.648 8.8945c1.1133-1.9414 3.5938-2.6094 5.5352-1.4961 1.9414 1.1172 2.6094 3.5938 1.4961 5.5352l-31.16 54.082c-1.5312 2.6602-5.3164 2.6992-6.9336 0.17578l-13.758-21.375c-1.2109-1.8867-0.66406-4.4023 1.2227-5.6133 1.8906-1.2109 4.4023-0.66406 5.6133 1.2227l10.152 15.773 27.836-48.305zm-27.648 88.605c26.234 0 47.5-21.266 47.5-47.5 0-2.2461-1.8203-4.0703-4.0703-4.0703s-4.0703 1.8242-4.0703 4.0703c0 21.734-17.621 39.355-39.355 39.355-21.738 0-39.359-17.621-39.359-39.355s17.621-39.355 39.355-39.355c2.25 0 4.0703-1.8242 4.0703-4.0703 0-2.2461-1.8242-4.0703-4.0703-4.0703-26.234-0.003906-47.5 21.262-47.5 47.496s21.266 47.5 47.5 47.5z" fillRule="evenodd">
                  </path>
                </svg>
              </div>
              <p className="feature-text">
                Acceso a las Asambleas, Notas, Reglamento de Copropiedad y Novedades.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* App Section */}
      <section className="app-section">
        <div className="container app-content">
          <div className="app-text">
            <h2>La nueva app ya está disponible en Android y iOS</h2>
            <p>
              Nos renovamos y eso incluye a la nueva app, más estilizada, más funciones, más soluciones. ConsorciosEnRed+
            </p>
          </div>
          <div className="app-image">
            <img src="/images/mobileapp.jpg" alt="App móvil ConsorciosEnRed+" />
          </div>
        </div>
      </section>

      {/* Brand Section */}
      <section className="brand-section">
        <div className="container">
          <h2 className="brand-title">Un producto de Sistemas Administrativos</h2>
        </div>
      </section>

      {/* Carousel Section */}
      <section className="carousel-section">
        <div className="container">
          <div 
            className="custom-carousel"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <button className="carousel-arrow carousel-arrow-left" onClick={prevSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="white"/>
              </svg>
            </button>
            
            <div className="carousel-track-container">
              <div 
                className="carousel-track"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                  <div key={slideIndex} className="carousel-slide-group">
                    {carouselItems
                      .slice(slideIndex * itemsPerSlide, (slideIndex + 1) * itemsPerSlide)
                      .map((item) => (
                        <div key={item.id} className="carousel-card">
                          <img src={item.image} alt={item.title} />
                          <div className="carousel-caption">
                            <h3>{item.title}</h3>
                          </div>
                        </div>
                      ))}
                  </div>
                ))}
              </div>
            </div>

            <button className="carousel-arrow carousel-arrow-right" onClick={nextSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z" fill="white"/>
              </svg>
            </button>
            {/*
            <div className="carousel-dots">
              {carouselItems.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Ir a slide ${index + 1}`}
                />
              ))}
            </div>
            */}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container contact-content">
          <div className="contact-image">
            <img src="/images/sistemasadministrativosLogo.png" alt="Sistemas Administrativos Logo" />
          </div>
          <div className="contact-form-wrapper">
            <h2>Sos Administrador?</h2>
            <p>Si te interesan nuestros otros servicios contactate con nosotros</p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="nombre">Nombre</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChange}
                  disabled={enviando}
                  placeholder="Ingresa tu nombre"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  disabled={enviando}
                  placeholder="ejemplo@email.com"
                />
              </div>
              <div className="form-group">
                <label htmlFor="mensaje">Mensaje</label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  rows="4"
                  value={formData.mensaje}
                  onChange={handleInputChange}
                  disabled={enviando}
                  placeholder="Escribí tu consulta aquí..."
                />
              </div>

              {/* Mensaje de resultado */}
              {mensajeResultado && (
                <div
                  className={`mensaje-resultado ${mensajeResultado.tipo}`}
                  style={{
                    padding: '12px',
                    marginBottom: '16px',
                    borderRadius: '4px',
                    backgroundColor: mensajeResultado.tipo === 'success' ? '#d4edda' : '#f8d7da',
                    color: mensajeResultado.tipo === 'success' ? '#155724' : '#721c24',
                    border: `1px solid ${mensajeResultado.tipo === 'success' ? '#c3e6cb' : '#f5c6cb'}`
                  }}
                >
                  {mensajeResultado.texto}
                </div>
              )}

              <button
                type="submit"
                className="btn-submit"
                disabled={enviando}
              >
                {enviando ? 'Enviando...' : 'Enviar'}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container footer-content">
          <div className="footer-column footer-empty">
            {/* Primera columna vacía */}
          </div>
          <div className="footer-column footer-center">
            <img
              src="https://irp.cdn-website.com/9065d057/dms3rep/multi/232540564_padded_logo.png"
              alt="Logo"
              className="footer-logo"
            />
            <button className="btn-footer-inicio" onClick={scrollToTop}>Volver al Inicio</button>
          </div>
          <div className="footer-column footer-links">
            <div className="social-links">
              <a href="mailto:contacto@ejemplo.com" className="social-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                </svg>
              </a>
              <a href="tel:+1234567890" className="social-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="currentColor"/>
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.8 2H16.2C19.4 2 22 4.6 22 7.8V16.2C22 17.7383 21.3889 19.2135 20.3012 20.3012C19.2135 21.3889 17.7383 22 16.2 22H7.8C4.6 22 2 19.4 2 16.2V7.8C2 6.26174 2.61107 4.78649 3.69878 3.69878C4.78649 2.61107 6.26174 2 7.8 2ZM7.6 4C6.64522 4 5.72955 4.37928 5.05442 5.05442C4.37928 5.72955 4 6.64522 4 7.6V16.4C4 18.39 5.61 20 7.6 20H16.4C17.3548 20 18.2705 19.6207 18.9456 18.9456C19.6207 18.2705 20 17.3548 20 16.4V7.6C20 5.61 18.39 4 16.4 4H7.6ZM17.25 5.5C17.5815 5.5 17.8995 5.6317 18.1339 5.86612C18.3683 6.10054 18.5 6.41848 18.5 6.75C18.5 7.08152 18.3683 7.39946 18.1339 7.63388C17.8995 7.8683 17.5815 8 17.25 8C16.9185 8 16.6005 7.8683 16.3661 7.63388C16.1317 7.39946 16 7.08152 16 6.75C16 6.41848 16.1317 6.10054 16.3661 5.86612C16.6005 5.6317 16.9185 5.5 17.25 5.5ZM12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7ZM12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9Z" fill="currentColor"/>
                </svg>
              </a>
              <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="social-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382C17.205 14.248 15.859 13.586 15.614 13.492C15.37 13.398 15.194 13.351 15.018 13.619C14.842 13.887 14.304 14.498 14.152 14.674C14 14.85 13.847 14.874 13.58 14.74C13.313 14.606 12.457 14.331 11.438 13.422C10.644 12.712 10.105 11.84 9.952 11.572C9.8 11.304 9.938 11.161 10.072 11.027C10.192 10.907 10.34 10.715 10.474 10.563C10.608 10.411 10.656 10.295 10.75 10.119C10.844 9.943 10.796 9.791 10.73 9.657C10.664 9.523 10.126 8.175 9.905 7.639C9.684 7.103 9.463 7.175 9.311 7.175C9.159 7.175 8.983 7.163 8.807 7.163C8.631 7.163 8.34 7.229 8.095 7.497C7.85 7.765 7.141 8.427 7.141 9.775C7.141 11.123 8.119 12.423 8.253 12.599C8.387 12.775 10.105 15.493 12.711 16.625C13.318 16.897 13.794 17.057 14.168 17.177C14.775 17.367 15.33 17.343 15.773 17.277C16.263 17.211 17.355 16.649 17.576 16.027C17.797 15.405 17.797 14.866 17.731 14.756C17.665 14.646 17.489 14.58 17.222 14.446L17.472 14.382ZM12.012 21.79C10.314 21.79 8.634 21.337 7.149 20.481L6.78 20.272L3.527 21.116L4.382 17.946L4.151 17.565C3.221 16.027 2.727 14.263 2.727 12.451C2.727 7.303 6.864 3.166 12.012 3.166C14.514 3.166 16.872 4.099 18.652 5.879C19.5308 6.75118 20.2275 7.78474 20.7049 8.92522C21.1824 10.0657 21.4315 11.2898 21.437 12.527C21.437 17.675 17.3 21.812 12.152 21.812L12.012 21.79ZM20.405 3.488C19.3036 2.37888 17.9922 1.49632 16.5481 0.889382C15.1039 0.282445 13.5553 -0.0186186 11.992 0.000184774C5.438 0.000184774 0.095 5.343 0.095 11.897C0.095 13.988 0.671 16.031 1.769 17.815L0 24L6.305 22.267C8.024 23.273 10.002 23.805 12.012 23.805C18.566 23.805 23.909 18.462 23.909 11.908C23.909 8.735 22.722 5.738 20.558 3.573L20.405 3.488Z" fill="currentColor"/>
                </svg>
              </a>
            </div>
            <button className="btn-app">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 18C6 18.55 6.45 19 7 19H8V22.5C8 23.33 8.67 24 9.5 24C10.33 24 11 23.33 11 22.5V19H13V22.5C13 23.33 13.67 24 14.5 24C15.33 24 16 23.33 16 22.5V19H17C17.55 19 18 18.55 18 18V8H6V18ZM3.5 8C2.67 8 2 8.67 2 9.5V16.5C2 17.33 2.67 18 3.5 18C4.33 18 5 17.33 5 16.5V9.5C5 8.67 4.33 8 3.5 8ZM20.5 8C19.67 8 19 8.67 19 9.5V16.5C19 17.33 19.67 18 20.5 18C21.33 18 22 17.33 22 16.5V9.5C22 8.67 21.33 8 20.5 8ZM15.53 2.16L16.83 0.86C17.03 0.66 17.03 0.35 16.83 0.15C16.63 -0.05 16.32 -0.05 16.12 0.15L14.64 1.63C13.85 1.23 12.95 1 12 1C11.04 1 10.14 1.23 9.34 1.63L7.85 0.15C7.65 -0.05 7.34 -0.05 7.14 0.15C6.94 0.35 6.94 0.66 7.14 0.86L8.45 2.17C6.97 3.26 6 5.01 6 7H18C18 5.01 17.03 3.25 15.53 2.16ZM10 5H9V4H10V5ZM15 5H14V4H15V5Z" fill="currentColor"/>
              </svg>
              Android
            </button>
            <button className="btn-app">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.05 20.28C16.03 21.23 14.96 21.08 13.95 20.63C12.88 20.17 11.91 20.15 10.79 20.63C9.36 21.25 8.61 21.07 7.72 20.28C2.42 14.97 3.19 6.46 9.33 6.15C10.76 6.22 11.78 6.95 12.62 7C13.95 6.76 15.23 6.01 16.66 6.1C18.41 6.21 19.73 6.91 20.61 8.2C17.25 10.2 18.06 14.72 21.26 16C20.61 17.58 19.75 19.15 17.04 20.29L17.05 20.28ZM12.53 6.09C12.37 3.96 14.09 2.22 16.09 2C16.37 4.45 13.85 6.27 12.53 6.09Z" fill="currentColor"/>
              </svg>
              iOS
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;
